const getCurrentTimestamp = () => {
  return new Date().getTime()
}

export { getCurrentTimestamp }
